export enum PartnerPlan {
  Basic = 3,
  Plus = 2,
  Enterprise = 1
}
